module.exports = __webpack_public_path__ + "img/89.07a2db88.jpg";